import React from 'react'

export const CellTieRule = React.memo(({ extendedResults}) => {
    const rule = extendedResults?.filter(er => er?.er_code === 'RULE')?.map(val => val?.er_value);
    const tie = extendedResults?.filter(er => er?.er_code === 'MS')?.map(val => val?.er_value);
    const resp = rule?.length > 0 ? rule : tie?.length > 0 ? '(' + tie + ')' : ''
    return resp;
});
